import { Injectable } from '@angular/core';

import { pipeFns } from '../../utils/pipe-fns';
import { AwningTypes } from './models/awning-types';
import { Position } from '../../classes/position';
import { Rotation } from '../../classes/rotation';
import { Xyz } from '../../models/2d3d/xyz';
import { AwningColorTextureService } from './awning-color-texture.service';
import { AwningService } from './awning.service';
// import { AwningColorTextureService } from './awning-color-texture.service';

declare const THREE: any;

export interface AwningExtensionConfig {
  id: string;
  position: Xyz;
  rotation: Xyz;
  basePosition: Xyz;
}

export interface AwningConfig {
  id: string;
  position: Xyz;
  rotation: Xyz;
  color?: any;
  texture?: any;
  extensions?: AwningExtensionConfig[];
}

@Injectable()
export class AwningSaveDataService {
  box = new THREE.Box3();

  constructor(
    private awningColorTextureService: AwningColorTextureService,
    private awningService: AwningService
  ) {}

  private _createConfig(awning): AwningConfig | AwningExtensionConfig {
    const { x, y, z } = new THREE.Euler().setFromQuaternion(awning.getWorldQuaternion(), 'XYZ');
    return {
      id: awning.userData.entity.id,
      position: new Position(
        awning.getWorldPosition(new THREE.Vector3()).x,
        awning.getWorldPosition(new THREE.Vector3()).y,
        awning.getWorldPosition(new THREE.Vector3()).z
      ),
      rotation: new Rotation(x, y, z)
    };
  }

  getAwningsByFloorAndWallId(floor: any, wallId: number): any[] {
    let awnings = [];
    const walls = floor.children.filter(element => element.name === 'wall');
    const wall = walls.find(element => element.userData.uuid === wallId);
    awnings = wall && wall.children.filter(obj => this.awningService.isAwning(obj));
    return awnings;
  }

  // logic (start)
  gatherAwningsData(floor: any, wallId: number): any {
    // save data for project saving,
    // rebuilding floor, etc
    let awnings = this.getAwningsByFloorAndWallId(floor, wallId);
    let configs: {
      color: any;
      texture: any;
      items: AwningConfig[];
    } = {
      color: null,
      texture: null,
      items: []
    };
    configs.texture = this.awningColorTextureService.glassTexture;
    configs.color = this.awningColorTextureService.frameColor;
    if (awnings.length > 0) {
      awnings.forEach(awning => {
        const config = this._createConfig(awning);
        configs.items.push(config);
        const extensions = this.awningService.getExtensions(awning);
        if (extensions.length) {
          // if extensions are available
          // concat it to the main array
          // to make sure base awning is the first
          // element in it (to attach extension to it)
          const extensionConfigs = extensions.map(ext => {
            const config = this._createConfig(ext);
            (<AwningExtensionConfig>config).basePosition = { ...awning.position };
            return config;
          });
          (<AwningConfig>config).extensions = extensionConfigs;
        }
      });
    }
    return configs;
  }
  // logic (end)
}



// WEBPACK FOOTER //
// ./src/app/services/awning/awning-save-data.service.ts